export default __webpack_public_path__ + "static/media/sergel-intro.599c8f15.jpg";